import ClosureSurveyData from 'sprockets_react/closure_survey/data/registry'

ClosureSurveyData.seedData = function() {
  return {
    outcome: null,
    providerAccountId: null,
    providerAccountName: null,
    rating: null,
    comments: null,
    selectedReasons: [],
    value: null
  }
}

ClosureSurveyData.Data = ClosureSurveyData.seedData()
